// extracted by mini-css-extract-plugin
export default {"h3":"About_h3__b7Y7v","h4":"About_h4__T6VZR","article":"About_article__LNdK9","p":"About_p__jQHcX"};